import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "files" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "relative" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Badge = _resolveComponent("Badge")
  const _component_Loader = _resolveComponent("Loader")
  const _component_FilesUpload = _resolveComponent("FilesUpload")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createTextVNode(" Files ")),
          ($setup.$files.total)
            ? (_openBlock(), _createBlock(_component_Badge, {
                key: 0,
                gray: "",
                style: {"width":"max-content"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.$files.total), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ]),
        ($options.show_refreshing)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              inline: "",
              small: ""
            }))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "container",
      onDragover: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.dragover && $options.dragover(...args)), ["prevent"])),
      onDrop: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.drop && $options.drop(...args)), ["prevent"])),
      onDragleave: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.dragleave && $options.dragleave(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_5, [
        ($options.show_loading)
          ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
          : ($options.show_empty)
            ? (_openBlock(), _createBlock($setup["FilesEmpty"], {
                key: 1,
                onUpload: $options.onUpload
              }, null, 8 /* PROPS */, ["onUpload"]))
            : (_openBlock(), _createBlock($setup["FilesTable"], {
                key: 2,
                ref: "table",
                files: $setup.$files.files,
                loading: $options.loading,
                count: $setup.$files.count,
                "all-exts": $setup.EXTS,
                skip: $data.load_params.skip,
                highlight: $data.highlight,
                onUpload: $options.onUpload,
                onUpdate: $options.loadItems,
                onDelete: $options.onDelete
              }, null, 8 /* PROPS */, ["files", "loading", "count", "all-exts", "skip", "highlight", "onUpload", "onUpdate", "onDelete"])),
        _withDirectives(_createVNode($setup["FilesDrop"], {
          error: $data.error,
          exts: $setup.EXTS
        }, null, 8 /* PROPS */, ["error", "exts"]), [
          [_vShow, $data.active && !$options.show_loading]
        ])
      ])
    ], 32 /* NEED_HYDRATION */),
    _withDirectives(_createVNode(_component_FilesUpload, {
      uploads: $setup.$files.uploads,
      class: "files-upload",
      onDelete: _cache[3] || (_cache[3] = $event => ($setup.$files.deleteUpload($event)))
    }, null, 8 /* PROPS */, ["uploads"]), [
      [_vShow, $setup.$files.uploads.length > 0]
    ])
  ]))
}